import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  root: {
    borderRight: `1px solid ${theme.palette.divider}`,
    borderLeft: `1px solid ${theme.palette.divider}`,
  },
}))
